import { Box, Button, Dialog, Typography } from "@mui/material";
import { useSettings } from "contexts/Settings";
import { mixpanelService as mixpanel } from 'services/tracking';
import { ISolvedActivity } from "services/Interfaces";
import { ISolvedUserActivity } from "./ISolvedLandingPage";

interface RedirectToISolvedDialogProps {
  open: boolean;
  onClose: () => void;
  lastName: string;
  userId?: string;
  addIsolvedUserActivityToRecord: (activity: ISolvedUserActivity) => Promise<void>;
}

const navigateToIsolved = async (isolvedUrl: string, lastName: string, addIsolvedUserActivityToRecord: (activity: ISolvedUserActivity) => Promise<void>, userId?: string) => {
  await addIsolvedUserActivityToRecord({
    activity: ISolvedActivity.UserRedirectedToIsolved,
    type: "user",
    userId,
    timestamp: new Date(),
    lastName,
  });
  mixpanel.track(ISolvedActivity.UserRedirectedToIsolved, {
    lastName,
  });
  window.location.href = isolvedUrl;
};

const RedirectToISolvedDialog = ({ open, onClose, lastName, userId, addIsolvedUserActivityToRecord }: RedirectToISolvedDialogProps) => {
  const { settings } = useSettings();

  return (
    <Dialog open={open} onClose={onClose}>
      <Box
        sx={{
          p: 3,
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <Typography variant="h6">
          In order to proceed, we need to sync your information from isolved.
          You will be redirected to your account in the isolved COBRA portal,
          where you can provide your consent for isolved to share your
          information with When. Once you have provided your consent,
          you&apos;ll return to When and can create your account.
        </Typography>
        <Button variant="contained" color="primary" onClick={() => navigateToIsolved(settings.REACT_APP_ISOLVED_CONSENT_URL, lastName, addIsolvedUserActivityToRecord, userId)}>
          Continue
        </Button>
      </Box>
    </Dialog>
  );
};

export default RedirectToISolvedDialog;